import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

function useSubDistricts(districtId) {
  const [subDistricts, setSubDistricts] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const dis = await dataProvider.getList("sub-districts", {
          filter: { district_id: districtId },
        });
        setSubDistricts(dis.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districtId]);

  return {
    subDistricts,
    loading,
    error,
  };
}

export default useSubDistricts;
